import React from "react"
import constants from "../constants"
import Store from "../store"

const FullVideo = (props) => {
  const isMobile = Store.version === constants.MOBILE
  return (
    <div className={`${props.className} relative`}>
      <video
        className={`${props.videoClassName} w-full h-full`}
        controls
        loop
        autoPlay
        style={props.videoStyle}
      >
        <source src={isMobile ? props.srcMobile : props.srcDesktop} type="video/mp4" />
      </video>
    </div>
  )
}

export default FullVideo
